import {
  LOAD_STRUCTURE,
  SHOW_STRUCTURE,
  CREATE_STRUCTURE,
  UPDATE_STRUCTURE,
  DELETE_STRUCTURE,
  IMPORT_STRUCTURE,
  EXPORT_STRUCTURE,
} from "./actions";

const msg = {
  success_msg: "",
  err_msg: "",
};

const initialState = {
  lists: [],
  total_rows: 0,
  loading: false,
  shouldReload: false,
  data: {
    id: "",
    code: "",
    name: "",
    // is_slow_dump: "N",
    // percent_spare_volume: "",
    // small_truck_dump_rate: "",
    // big_truck_dump_rate: "",
    // remark: "",
    // fileList_icon_src: [],
    // fileList_img_src: [],
    // fileList_icon_src_selected: [],
  },
  id: "",
  ...msg,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_STRUCTURE.REQUEST:
    case UPDATE_STRUCTURE.REQUEST:
    case DELETE_STRUCTURE.REQUEST:
    case IMPORT_STRUCTURE.REQUEST:
    case EXPORT_STRUCTURE.REQUEST:
      return {
        ...state,
        ...msg,
        loading: true,
        shouldReload: false,
      };
    case LOAD_STRUCTURE.REQUEST:
      return {
        ...state,
        data: initialState.data,
        ...msg,
        loading: true,
        shouldReload: false,
      };
    case SHOW_STRUCTURE.REQUEST:
      return {
        ...initialState,
        ...msg,
        loading: true,
        shouldReload: false,
      };

    case LOAD_STRUCTURE.SUCCESS:
      return {
        ...state,
        lists: action.payload.data.data,
        total_rows: action.payload.data.total_rows,
        loading: false,
      };

    case SHOW_STRUCTURE.SUCCESS:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.payload.data.data,
          icon_src: action.payload.data.data.icon_src,
          img_src: action.payload.data.data.img_src,
          icon_src_selected: action.payload.data.data.icon_src_selected,
          fileList_icon_src:
            action.payload.data.data.icon_src !== null &&
              action.payload.data.data.icon_src !== ""
              ? [
                {
                  uid: "1",
                  name: "icon_src.png",
                  status: "done",
                  url: action.payload.data.data.icon_src,
                },
              ]
              : [],
          fileList_img_src:
            action.payload.data.data.img_src !== null &&
              action.payload.data.data.img_src !== ""
              ? [
                {
                  uid: "1",
                  name: "img_src.png",
                  status: "done",
                  url: action.payload.data.data.img_src,
                },
              ]
              : [],
          fileList_icon_src_selected:
            action.payload.data.data.icon_src_selected !== null &&
              action.payload.data.data.icon_src_selected !== ""
              ? [
                {
                  uid: "1",
                  name: "icon_src_selected.png",
                  status: "done",
                  url: action.payload.data.data.icon_src_selected,
                },
              ]
              : [],
        },
        loading: false,
      };

    case CREATE_STRUCTURE.SUCCESS:
      return {
        ...state,
        success_msg: "save_success",
        id: action.payload.data.data.id,
        loading: false,
      };

    case UPDATE_STRUCTURE.SUCCESS:
      return {
        ...state,
        success_msg: "edit_success",
        loading: false,
      };

    case DELETE_STRUCTURE.SUCCESS:
      return {
        ...state,
        success_msg: "delete_success",
        lists: state.lists.filter((x) => x.id !== action.payload.id),
        loading: false,
        shouldReload: true,
      };

    case IMPORT_STRUCTURE.SUCCESS:
      return {
        ...state,
        success_msg: "import_success",
        loading: false,
        shouldReload: true,
      };

    case EXPORT_STRUCTURE.SUCCESS:
      return {
        ...state,
        success_msg: "export_success",
        loading: false,
      };
    case LOAD_STRUCTURE.FAILURE:
    case SHOW_STRUCTURE.FAILURE:
    case CREATE_STRUCTURE.FAILURE:
    case UPDATE_STRUCTURE.FAILURE:
    case DELETE_STRUCTURE.FAILURE:
    case IMPORT_STRUCTURE.FAILURE:
    case EXPORT_STRUCTURE.FAILURE:
      return {
        ...state,
        err_msg: action.payload.err,
        loading: false,
        shouldReload: false,
      };

    default:
      return state;
  }
};
